import React from "react";
import { useSelector } from "react-redux";
import formateNumber from "../formateNumber";

export default function TotalItem() {
  const cart = useSelector((state) => state.cart);
  const totalItem = cart.reduce(
    (currentValue, element) => currentValue + element.quantity,
    0
  );
  return (
    <div className="flex justify-center items-center text-center">
      <div className="text-xl font-semibold">
        <p>Total Item</p>
        <p className="text-5xl">{formateNumber(totalItem)}</p>
      </div>
    </div>
  );
}
